import React from 'react';
import '../../styles/PartnerTestimonial.css';

function PartnerTestimonial() {
  const testimonials = [
    {
      id: 1,
      quote: `Simon Yio strikes you immediately as an excellent teacher... His knowledge of the subject, ability to communicate that knowledge... His teaching style is wonderful, full of humor and stories, and most importantly real-world examples... Simon Yio was always there for my support... He gives you the constant feeling you are dealing with a friend who cares... I will always appreciate him for empowering me with the ability to negotiate with confidence and with understanding.`,
      author: 'Amr Mohssen',
    },
    {
      id: 2,
      quote: `Thank you for being a caring and dynamic team leader... You are truly a leader, and have groomed many of us to where we are today... As a mentor, you are always there to help anyone resolve issues... With the enthusiasm you have in creating and facilitating course programs, you act more like a mentor and a friend... I was motivated by you when you shared how to build a strong sales team... You want to see us succeed in this industry, whether in personal sales or in building a sales team.`,
      author: 'Andrew Se',
    },
    {
      id: 3,
      quote: `Mr. Simon Yio is different from other leaders... He advised me to reconsider and visit more agencies, showing his professionalism and care... Despite leading a team of over 200 associates, his enthusiasm to help has never faded... With his years of industry knowledge, training, and guidance, I’ve built a successful career... He reminds us to be professional and ethical... His performance exceeds my expectations, and he conducts himself with maturity, diligence, and trustworthiness... I’m glad to have him as my team leader and mentor.`,
      author: 'Billion Tan',
    },
  ];

  const handleReadMore = () => {
    window.location.href = '/partner-testimonials'; // Create this route or static page
  };

  return (
    <section className="section text-center">
      <div className="testimonialCardContainer">
        {testimonials.map((t) => (
          <div key={t.id} className="partnerTestimonialCard">
            <div className="stars">
              {[...Array(5)].map((_, i) => (
                <svg key={i} className="starIcon" viewBox="0 0 20 20" fill="#FFD700">
                  <path d="M10 1l2.47 6.97h7.35l-5.94 4.32 2.28 7.01L10 14.9l-6.16 4.41 2.28-7.01L.18 7.97h7.35L10 1z" />
                </svg>
              ))}
            </div>
            <h3 className="testimonialHeading">TESTIMONIAL</h3>
            <p className="testimonialQuote">{t.quote}</p>
            <p className="testimonialAuthor">{t.author}</p>
          </div>
        ))}
      </div>
      <button className="readMoreBtn" onClick={handleReadMore}>
        Read More...
      </button>
    </section>
  );
}

export default PartnerTestimonial;
